/* =====================================================================
   AstaLab 2.0 — banner di modalità demo (sezione 12 del round 2.0.0-alpha.1)

   Renderizzato UNA VOLTA, in un punto solo del layout condiviso
   (ui/app-shell.js), leggendo `adapter.kind` — NON è un "if (artifact)"
   sparso nella business logic: è l'unico posto di tutta la UI che
   controlla quale adapter è attivo, ed esiste solo per mostrare un
   messaggio onesto, mai per cambiare cosa succede quando l'utente clicca
   un pulsante (quello lo decide sempre e solo l'adapter stesso).
   ===================================================================== */
export function renderDemoModeBanner(env){
  if(env.hasNetworkBackend) return "";
  return (
    '<div class="demo-banner" role="status">' +
      '<strong>Modalità demo Artifact — backend cloud non disponibile in questo ambiente.</strong> ' +
      'Account, aste e dati che crei qui restano solo in questo browser: nessuna registrazione ' +
      'reale su Supabase, nessuna email inviata, nessuna sincronizzazione sul cloud, nessun altro ' +
      'utente realmente connesso.' +
    '</div>'
  );
}

/** Mostra il campo `notice` di un risultato di un BackendAdapter, se presente — stesso principio:
 *  le pagine non decidono la formulazione in base all'adapter, si limitano a mostrare ciò che
 *  l'adapter stesso (demo o reale) ha scelto di dire. */
export function renderNoticeIfAny(result){
  if(!result || !result.notice) return "";
  return '<p class="notice">' + escapeHtmlLocal(result.notice) + "</p>";
}

function escapeHtmlLocal(s){
  return String(s==null?"":s).replace(/[&<>"']/g, c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
}
